import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const CancellationPolicy = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      <nav className="nav-header">
        <div className="nav-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <img 
            src="https://customer-assets.emergentagent.com/job_returnpal-pickup/artifacts/x8ux114u_Screenshot%202026-04-27%20165324.png" 
            alt="ReturnPal" 
            className="logo-image" 
            style={{ height: "50px", width: "auto" }}
          />
        </div>
        <Button onClick={() => navigate(-1)} variant="outline">
          <ArrowLeft size={16} style={{ marginRight: '0.5rem' }} />
          Back
        </Button>
      </nav>

      <div style={{ maxWidth: '900px', margin: '2rem auto', padding: '0 2rem' }}>
        <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '3rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '1rem', color: '#1f2937' }}>
            Cancellation & Refund Policy
          </h1>
          <p style={{ color: '#6b7280', marginBottom: '2rem' }}>Effective Date: April 1, 2026</p>

          <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '2rem' }}>
            This Cancellation & Refund Policy governs all bookings and payments made for ReturnPal services.
          </p>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>1. General Policy</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563' }}>
              All payments are final once services have been rendered. ReturnPal operates as a time- and logistics-based service, and fees are charged for scheduled service commitments rather than delivery outcomes.
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>2. Cancellations</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563' }}>
              Customers may cancel a scheduled pickup prior to the start of the designated pickup window without penalty.
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>3. Late Cancellations</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '0.5rem' }}>
              Cancellations made:
            </p>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>Within the active pickup window; or</li>
              <li>After dispatch of a ReturnPal driver</li>
            </ul>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginTop: '0.5rem' }}>
              may be considered late cancellations and may be subject to a service fee or forfeiture of the booking.
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>4. Failed or Missed Pickups</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '0.5rem' }}>
              A pickup will be considered completed or forfeited if:
            </p>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>The Customer is unavailable at the scheduled time</li>
              <li>Packages are not accessible</li>
              <li>Incorrect or incomplete pickup information is provided</li>
              <li>No packages are available at the time of arrival</li>
            </ul>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginTop: '0.5rem', fontWeight: '600' }}>
              In such cases:
            </p>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>No refund will be issued</li>
              <li>A new booking may be required at the applicable rate</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>5. Refunds</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '0.5rem' }}>
              Refunds will not be issued under the following circumstances:
            </p>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>After a successful pickup has been completed</li>
              <li>For missed or failed pickups due to customer error</li>
              <li>For subscription services once billed</li>
              <li>For unused services within an active billing cycle</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>6. Subscription Cancellations</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '0.5rem' }}>
              Customers may cancel their subscription at any time prior to the next billing cycle.
            </p>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>Cancellation prevents future billing</li>
              <li>No refunds are provided for the current billing period</li>
              <li>Unused services do not carry over</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>7. Rescheduling</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563' }}>
              ReturnPal may allow rescheduling requests based on availability. Rescheduling is not guaranteed and may be treated as a new booking depending on timing and circumstances.
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>8. Service Disruptions</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '0.5rem' }}>
              In the event of service disruptions caused by factors outside ReturnPal's control (including but not limited to weather, carrier delays, or operational issues), ReturnPal may, at its discretion:
            </p>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>Reschedule the service; or</li>
              <li>Provide alternative accommodations</li>
            </ul>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginTop: '0.5rem' }}>
              Such events do not automatically qualify for refunds.
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>9. Right to Modify Policy</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563' }}>
              ReturnPal reserves the right to modify this Cancellation & Refund Policy at any time. Updates will be effective upon posting.
            </p>
          </section>

          <div style={{ 
            marginTop: '3rem', 
            padding: '1.5rem', 
            backgroundColor: '#fef3c7', 
            borderRadius: '8px', 
            border: '2px solid #f59e0b' 
          }}>
            <p style={{ fontWeight: '600', color: '#92400e', marginBottom: '0.5rem' }}>Important Notice:</p>
            <p style={{ color: '#78350f', lineHeight: '1.6' }}>
              By using ReturnPal services, you acknowledge acceptance of this Cancellation & Refund Policy.
              <br />
              <strong>All policies are governed by the laws of the State of Arizona</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;
